// import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js'
import './SubscriptionPayment.scss'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../utils/redux/userSlice'
import { Machine } from '../../../utils/models/Machine'
import { Form, InputGroup } from 'react-bootstrap'
import { AWSelect } from 'aw-select'
import { CountriesList } from 'aw-consts'
import { useState } from 'react'
import { set } from 'date-fns'
import { useTranslation } from 'react-i18next'


const SubscriptionPayment = (props: { onCompletePayment: () => void, machine: Machine, connection: number, country: number, priceId: string, trialDays: number }) => {

    const user = useSelector(selectUser)
    const { t } = useTranslation();
    const countries = CountriesList()

    const date = new Date()
    date.setDate(date.getDate() + props.trialDays)

    return (
        <div className="stripe-demo-container border rounded-4 shadow-sm bg-white p-4 mx-auto" style={{ maxWidth: 400 }}>
            {/* Capçalera */}
            <div className="text-center mb-4">
                <h5 className="fw-semibold mb-1">{`30 ${t('FreeDays')}`}</h5>
                <p className="text-muted small mb-0">
                    {`${t('Continuously')}, `}<strong>1,00 €</strong>{` ${t('PerYearFrom')} ${date.toLocaleDateString()}. `}
                    <strong>{ }</strong>
                </p>
            </div>

            {/* Botó Link */}
            <button className="btn-Custom btn-IDGreen w-100 d-flex align-items-center justify-content-center gap-2 fw-semibold py-2 mb-3" >
                {t('PayWith')}
                <span className="bg-dark text-white rounded-pill px-2 py-1 small d-flex align-items-center">
                    ▶ link
                </span>
            </button>

            <div className="text-center text-muted small mb-3">
                {`— ${t('OrPayWithCard')} —`}
            </div>

            {/* Correu electrònic */}
            <Form.Group className="mb-3">
                <Form.Label className="small fw-semibold">{t('Email')}</Form.Label>
                <Form.Control
                    type="email"
                    disabled
                    value={user?.email}
                    className="bg-light border-0"
                />
            </Form.Group>

            {/* Mètode de pagament */}
            <h6 className="fw-semibold mb-2">{t('PaymentMethod')}</h6>

            <Form.Group className="mb-3">
                <Form.Label className="small">{t('CardInformation')}</Form.Label>
                <InputGroup className="mb-2">
                    <Form.Control
                        type="text"
                        placeholder="1234 1234 1234 1234"
                        className="bg-light border"
                    />
                </InputGroup>
                <div className="d-flex gap-2">
                    <Form.Control
                        type="text"
                        placeholder="MM / AA"
                        className="bg-light border"
                    />
                    <Form.Control
                        type="text"
                        placeholder="CVC"
                        className="bg-light border"
                    />
                </div>
            </Form.Group>

            {/* Nom del titular */}
            <Form.Group className="mb-3">
                <Form.Label className="small">{t('TitularCardName')}</Form.Label>
                <Form.Control
                    type="text"
                    placeholder={t('CompletName')}
                    className="bg-light border"
                />
            </Form.Group>

            {/* País */}
            <Form.Group className="mb-4">
                <Form.Label className="small">{t('Country')}</Form.Label>
                <AWSelect dark={false} placeholder='Country' className="inputStyle selectStyle" closeMenuOnSelect={false} defaultValue={countries[0]} options={countries}
                    onChange={() => null} />
            </Form.Group>

            {/* Botó pagar */}
            <button
                // variant="primary"
                className="btn-Custom btn-IDGreen w-100 fw-semibold py-2"
                onClick={() => {
                    props.onCompletePayment()
                }}
            >
                {t('Pay')}
            </button>

            <p className="text-center text-muted small mt-3 mb-0">
                {t('ThisIsOnlyADemoPayment')}
            </p>
        </div>
    );
}






export default SubscriptionPayment